import { PageController } from '@client/components/_core/layout/PageController';
import { FieldConfigurationList } from '@client/components/field-configurations/FieldConfigurationList';
import { createFileRoute } from '@tanstack/react-router';
import { SlidersHorizontal } from 'lucide-react';

export const Route = createFileRoute('/console/$orgId/configuration/compliance/incidents/custom-fields')({
    staticData: {
        metadata: {
            title: 'Custom fields',
        },
        ui: {
            icon: SlidersHorizontal,
            title: 'Incident custom fields',
            subtitle: 'Define additional fields captured against incidents',
            menuDescription: 'Define additional fields captured against incidents',
        },
    },
    component: IncidentCustomFields,
});

function IncidentCustomFields() {
    return (
        <PageController route={Route}>
            <FieldConfigurationList entity="INCIDENT" showEntityConfiguration allowDuplicates />
        </PageController>
    );
}
